const TEST_HOUSES = [
    168, 330, 331, 332, 433, 846, 864, 865, 868, 869, 887, 889, 956, 1024, 1062, 1069, 1080, 3269, 6096,
];

export default TEST_HOUSES;
